export const ITEM_STORAGE_LOCATION_LOADING = 'ITEM_STORAGE_LOCATION_LOADING';
export const ITEM_STORAGE_LOCATION_DATA = 'ITEM_STORAGE_LOCATION_DATA';
export const CLEAR_ITEM_ERROR_SUCCESS = 'CLEAR_ITEM_ERROR_SUCCESS';
export const ITEM_STORAGE_LOCATION_LOADING_ERROR =
  'ITEM_STORAGE_LOCATION_LOADING_ERROR';

export const ITEM_STORAGE_LOCATION_SUBMIT_ERROR =
  'ITEM_STORAGE_LOCATION_SUBMIT_ERROR';
export const ITEM_STORAGE_LOCATION_SUBMITTING =
  'ITEM_STORAGE_LOCATION_SUBMITTING';
export const ITEM_STORAGE_LOCATION_SUBMIT = 'ITEM_STORAGE_LOCATION_SUBMIT';

export const ITEM_STORAGE_LOCATION_DROPDOWN_LOADING =
  'ITEM_STORAGE_LOCATION_DROPDOWN_LOADING';
export const ITEM_STORAGE_LOCATION_DROPDOWN_DATA =
  'ITEM_STORAGE_LOCATION_DROPDOWN_DATA';
export const ITEM_STORAGE_LOCATION_DROPDOWN_LOADING_ERROR =
  'ITEM_STORAGE_LOCATION_DROPDOWN_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/state/itemStorageLocation/types.js